// @ts-nocheck
import MinimumMultipleQuantityWarnings from "@store/Library/Components/Common/MinimumMultipleQuantityWarnings";
import PriceMatrix, { PriceMatrixStyles } from "@store/Library/Components/Common/PriceMatrix";
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import useWidgetBadges from "@insite/client-framework/Common/Hooks/useWidgetBadges";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import setWishListLineIsSelected from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/SetWishListLineIsSelected";
import updateWishListLine from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/UpdateWishListLine";
import translate from "@insite/client-framework/Translate";
import { WishListLineModel, WishListModel } from "@insite/client-framework/Types/ApiModels";
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import ProductDescription, { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import ProductPartNumbers, { ProductPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers";
import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import SmallHeadingAndText, { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import Checkbox, { CheckboxPresentationProps, CheckboxProps } from "@insite/mobius/Checkbox";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import Move from "@insite/mobius/Icons/Move";
import TextField, { TextFieldProps } from "@insite/mobius/TextField";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Icon, { IconPresentationProps, IconProps } from "@store/MobiusOverrides/Icon/Icon";
import ProductImage, { ProductImageStyles } from "@store/Overrides/Components/ProductImage";
import ProductTextBadges, { ProductTextBadgesStyles } from "@store/Overrides/Components/ProductTextBadges";
import useHandleMinimumMultupleSalesQuantity from "@store/Framework/Common/Hooks/useHandleMinimumMultupleSalesQuantity";
import useProductContext from "@store/Framework/Store/Data/Products/ProductsHooks/useProductContext";
import MyListDetailsSpecificationModal from "@store/Library/Components/Bunzl/MyListDetails/MyListDetailsSpecificationModal";
import ProductInventoryDetailMessage from "@store/Library/Components/Common/ProductInventoryDetailMessage";
import MyListDetailsProductControlsMobile from "@store/Library/Widgets/MyListDetails/MyListDetailsProductControlsMobile";
import GridItem, { GridItemProps } from "@store/MobiusOverrides/GridItem/GridItem";
import ProductImageBadges, {
    BadgeSizes,
    ProductImageBadgesStyles,
} from "@store/Overrides/Components/ProductImageBadges";
import { contentSpacingStyles } from "@store/Themes/common/mixins/spacing";
import { productLineProps } from "@store/Themes/common/props/productLineProps";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";
import React from "react";
import { LinkProps } from "react-router-dom";
import { SortableHandle } from "react-sortable-hoc";
import { css } from "styled-components";

interface MyDetailsProductLineStyles {
    productGridItem?: GridItemProps;
    selectedCheckbox?: CheckboxPresentationProps;
    checkboxSortOrderWrapper?: InjectableCss;
    productImageStyles?: ProductImageStyles;
    productInfosWrapper?: InjectableCss;
    productBrandStyles?: ProductBrandStyles;
    productDescriptionStyles?: ProductDescriptionStyles;
    partNumbersHidden?: HiddenProps;
    productPartNumbersStyles?: ProductPartNumbersStyles;
    notesStyles?: SmallHeadingAndTextStyles;
    notesHidden?: HiddenProps;
    partNumbersGridItem?: GridItemProps;
    productPriceStyles?: ProductPriceStyles;
    priceMatrixDesktop?: PriceMatrixStyles;
    sortOrderWrapper?: InjectableCss;
    dragHandleIcon?: IconPresentationProps;
    sortOrderTextField?: TextFieldProps;
    badgeWrapper?: InjectableCss;
    imageBadgeColumn?: InjectableCss;
    textBadgeStyles?: ProductTextBadgesStyles;
    imageBadgeStyles?: ProductImageBadgesStyles;
    deleteButtonWrapper?: InjectableCss;
    removeProductButton?: LinkProps;
    removeListLineIcon?: IconProps;
}

interface MyDetailsProductLineProps {
    isEditingSortOrder: boolean;
    canDrag?: boolean;
    isSelected: boolean;
    wishListLine: WishListLineModel;
    wishList: WishListModel;
    customWishListLineUpdate?: (wishListLine: WishListLineModel) => void;
    canEditWishList: boolean;
    extendedPrice: number;
    isQuantityUpdated: boolean;
    onUpdateQuantityClick: () => void;
    showTextBadges?: boolean;
    showImageBadges?: boolean;
    maxImageBadges?: number;
    maxTextBadges?: number;
    showSpecificationModal: boolean;
    onDeleteClick: (wishListLine: WishListLineModel) => void;
}

export const badgeSizes: BadgeSizes = {
    Small: {
        css: css`
            height: ${pxToRem(34)};
        `,
    },
    Medium: {
        css: css`
            height: ${pxToRem(34)};
        `,
    },
    Large: {
        css: css`
            height: ${pxToRem(50)};
        `,
    },
};
const myListDetailsProductLineStyles: MyDetailsProductLineStyles = {
    textBadgeStyles: {
        tagWrapper: {
            extendedStyles: {
                item: {
                    css: css`
                        max-height: ${pxToRem(34)};
                    `,
                },
                content: {
                    css: css`
                        display: flex;

                        align-items: center;
                    `,
                },
                wrapper: {
                    css: css`
                        display: flex;
                    `,
                },
            },
        },
    },
    partNumbersHidden: {
        below: "md",
        css: css`
            @media print {
                display: block;
            }
            width: 100%;
        `,
    },
    badgeWrapper: {
        css: css`
            display: flex;
            column-gap: 0.25rem;
            row-gap: 0.5rem;
            flex-wrap: wrap;
            ${breakpoint("sm", "down")} {
                margin-block: 0.3125rem;
                gap: 0.5rem;
            }
        `,
    },
    imageBadgeColumn: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 30%;
            gap: 0.25rem;
            // moved margin to the wrapping column instead of the image so that badges maintain spacing from the next element
            ${productLineProps.productImage?.linkWrappingImage?.css}
        `,
    },
    imageBadgeStyles: {
        badgeImageProps: {
            style: {
                width: "auto",
                height: "100%",
            },
        },
        flexWrapper: {
            extendedStyles: {
                content: {
                    css: css`
                        display: flex;
                        align-items: center;
                    `,
                },
                wrapper: {
                    css: css`
                        display: flex;
                        margin-bottom: 0;
                    `,
                },
            },
        },
        imageBadgeWrapperStyles: {
            css: css`
                height: ${pxToRem(34)};
            `,
        },
    },
    productPartNumbersStyles: {
        erpNumberGridItem: {
            css: css`
                justify-content: "flex-start";
            `,
        },
        container: {
            css: css`
                margin: 0;
                padding: 0;
                flex-grow: 0;
            `,
        },
    },
    // productBrandStyles: {
    //     nameText: {
    //         css: css`
    //             ${contentSpacingStyles(0, 0, pxToRem(5))}
    //         `,
    //     },
    //     nameLink: {
    //         css: css`
    //             ${contentSpacingStyles(0, 0, pxToRem(5))}
    //         `,
    //     },
    // },

    notesHidden: {
        above: "sm",
        css: css`
            @media print {
                display: none;
            }
            width: 100%;
        `,
    },
    productDescriptionStyles: productLineProps.productDescription,
    productInfosWrapper: productLineProps.productInfosWrapper,
    partNumbersGridItem: {
        width: 12,
        css: css`
            padding-left: 0;
            padding: 0;
        `,
    },
    selectedCheckbox: {
        sizeVariant: "small",
        css: css`
            @media print {
                display: none;
            }
            margin-right: ${pxToRem(10)};
        `,
    },
    productImageStyles: {
        ...productLineProps.productImage,
        wrapper: {
            css: css`
                width: 30%;
            `,
        },
    },
    checkboxSortOrderWrapper: {
        css: css`
            flex-direction: column;
            display: flex;
            row-gap: ${pxToRem(20)};
        `,
    },
    sortOrderTextField: {
        cssOverrides: {
            formField: css`
                width: 5rem;
            `,
            inputSelect: css`
                max-width: 2.5rem;
                text-align: center;
            `,
        },
    },
    priceMatrixDesktop: {
        wrapper: {
            css: css`
                @media (max-width: 1024px) {
                    display: none;
                }
            `,
        },
    },
    sortOrderWrapper: {
        css: css`
            display: flex;
            cursor: move;
        `,
    },
    dragHandleIcon: {
        src: Move,
        size: 28,
        color: "primary.main",
    },
    productGridItem: {
        ...productLineProps.productGridItem,
        css: css`
            ${productLineProps.productGridItem?.css}
            gap: ${pxToRem(8)};
        `,
        width: [12, 12, 12, 5, 5],
    },
    productPriceStyles: productLineProps.productPrice,
};
const styles = myListDetailsProductLineStyles;

const DragHandle = SortableHandle(() => {
    return (
        <StyledWrapper {...styles.sortOrderWrapper}>
            <Icon {...styles.dragHandleIcon} data-test-selector="myListDetailPage_DragSortOrder" />
        </StyledWrapper>
    );
});

const MyListDetailsProductListLineProductItem: React.FC<MyDetailsProductLineProps> = ({
    isEditingSortOrder,
    canDrag,
    isSelected,
    wishListLine,
    customWishListLineUpdate,
    wishList,
    canEditWishList,
    extendedPrice,
    isQuantityUpdated,
    onUpdateQuantityClick,
    showTextBadges,
    showImageBadges,
    maxTextBadges,
    maxImageBadges,
    showSpecificationModal,
    onDeleteClick,
}) => {
    const productSettings = useSettingsCollection().productSettings;
    const productContext = useProductContext();
    const { product, productInfo } = productContext;
    const { minimumQuantity, multipleQuantity } = useHandleMinimumMultupleSalesQuantity(product, productInfo);
    const dispatch = useAppDispatch();

    const selectChangeHandler: CheckboxProps["onChange"] = (_, value) => {
        dispatch(setWishListLineIsSelected({ wishListLineId: wishListLine.id, isSelected: value }));
    };

    const sortOrderBlurHandler = (event: React.FocusEvent<HTMLInputElement>) => {
        const sortOrder = Number(event.target.value);
        if (customWishListLineUpdate) {
            customWishListLineUpdate({ ...wishListLine, sortOrder });
            return;
        }
        dispatch(
            updateWishListLine({
                wishListLine: { ...wishListLine, sortOrder },
                wishListId: wishList.id,
                wishListLineId: wishListLine.id,
            }),
        );
    };
    const { imageBadges, textBadges } = useWidgetBadges({ productContext, showTextBadges, showImageBadges });

    return (
        <GridItem {...styles.productGridItem}>
            {!isEditingSortOrder && (
                <Checkbox
                    {...styles.selectedCheckbox}
                    checked={isSelected}
                    onChange={selectChangeHandler}
                    data-test-selector="selectItem"
                />
            )}
            {isEditingSortOrder && (
                <StyledWrapper {...styles.checkboxSortOrderWrapper}>
                    {canDrag && <DragHandle />}
                    <TextField
                        {...styles.sortOrderTextField}
                        label={translate("Sort Order")}
                        type="number"
                        min={1}
                        sizeVariant="small"
                        defaultValue={wishListLine.sortOrder}
                        onBlur={sortOrderBlurHandler}
                        data-test-selector="myListDetailPage_inputSortOrderLine"
                    />
                </StyledWrapper>
            )}
            <StyledWrapper>
                <ProductImage product={productContext} extendedStyles={styles.productImageStyles} />
            </StyledWrapper>

            <StyledWrapper {...styles.productInfosWrapper}>
                {product.brand && <ProductBrand brand={product.brand} extendedStyles={styles.productBrandStyles} />}
                <ProductDescription product={productContext} extendedStyles={styles.productDescriptionStyles} />
                <Hidden {...styles.partNumbersHidden}>
                    <ProductPartNumbers
                        productNumber={product.productNumber}
                        customerProductNumber={product.customerProductNumber}
                        manufacturerItem={product.manufacturerItem}
                        extendedStyles={styles.productPartNumbersStyles}
                    />
                    {wishListLine.notes && (
                        <SmallHeadingAndText
                            heading={translate("Notes")}
                            text={wishListLine.notes}
                            extendedStyles={styles.notesStyles}
                        />
                    )}
                </Hidden>
                {/* Starter Removed Code - Overflow Action Menu */}
                <Hidden {...styles.notesHidden}>
                    <GridItem {...styles.partNumbersGridItem}>
                        <ProductPartNumbers
                            productNumber={product.productNumber}
                            customerProductNumber={product.customerProductNumber}
                            manufacturerItem={product.manufacturerItem}
                            extendedStyles={styles.productPartNumbersStyles}
                        />
                    </GridItem>
                </Hidden>
                {showSpecificationModal && <MyListDetailsSpecificationModal />}
                <ProductPrice
                    product={productContext}
                    showSavings={true}
                    showSavingsAmount={productSettings.showSavingsAmount}
                    showSavingsPercent={productSettings.showSavingsPercent}
                    extendedStyles={styles.productPriceStyles}
                    showLabel={false}
                />

                {(showTextBadges && textBadges?.length) || (showImageBadges && imageBadges?.length) ? (
                    <StyledWrapper {...styles.badgeWrapper}>
                        {showTextBadges && textBadges && (
                            <ProductTextBadges
                                badgeList={textBadges}
                                maxBadges={maxTextBadges ?? 4}
                                extendedStyles={styles.textBadgeStyles}
                            />
                        )}
                        {showImageBadges && imageBadges && (
                            <ProductImageBadges
                                badgeSizes={badgeSizes}
                                badgeList={imageBadges}
                                maxBadges={maxImageBadges ?? 4}
                                extendedStyles={styles.imageBadgeStyles}
                                numberOfColumns={4}
                            />
                        )}
                    </StyledWrapper>
                ) : null}
                <MinimumMultipleQuantityWarnings
                    minimumQuantity={minimumQuantity}
                    multipleQuantity={multipleQuantity}
                />
                <ProductInventoryDetailMessage />
                <PriceMatrix extendedStyles={styles.priceMatrixDesktop} />
                <MyListDetailsProductControlsMobile
                    canEditWishList={canEditWishList}
                    wishListLine={wishListLine}
                    onDeleteClick={onDeleteClick}
                    extendedPrice={extendedPrice}
                    isQuantityUpdated={isQuantityUpdated}
                    onUpdateQuantityClick={onUpdateQuantityClick}
                />
            </StyledWrapper>
        </GridItem>
    );
};

export default MyListDetailsProductListLineProductItem;
